import { DateTime } from 'luxon';
import { Injectable } from '@angular/core';

@Injectable()

export class SuccessCompassDataService {

  dateObjectFromIso(date, timezone) {
    return DateTime.fromISO(date).setZone(timezone);
  }

  dateObjectFromMillis(date, timezone) {
    return DateTime.fromMillis(date).setZone(timezone);
  }

  now(timezone) {
    return DateTime.now().setZone(timezone);
  }

  toUTC(date) {
    return date.toUTC().valueOf();
  }
}
